"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
// Getting Server Name with browser default props
var getServerName = function () {
    var locationHostname = (0, utils_1.removeSpecialCharacters)(window.location.hostname);
    if (locationHostname
        .replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")
        .split("/")[0] !== undefined) {
        return locationHostname
            .replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")
            .split("/")[0]
            .toLowerCase();
    }
};
exports.default = getServerName;
